module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Thin-1372663afff16cfd7eadb03cd5869da3.woff";